import React from 'react';

class WinRate extends React.Component {

  render() {
    const winRateB = this.props.winRateBlack ? this.props.winRateBlack : 50.0;
    const winRateW = 100 - winRateB;
    const borderB = this.props.blackIsNext ? '3px solid red' : 'none';
    const borderW = this.props.blackIsNext ? 'none' : '3px solid red';

    return (
      <div>
        <div className="flex-container player bg-light bg-gradient">
          <div className="player-black">{this.props.gameInfo.PB}</div>
          <div className="capture-black">{this.props.captureBlack}</div>
          <div className="player-white">{this.props.gameInfo.PW}</div>
          <div className="capture-white">{this.props.captureWhite}</div>
        </div>
        <div className="progress">
          <div className="progress-bar progress-bar-black" role="progressbar"
            aria-valuenow={Math.round(winRateB)}
            aria-valuemin="0" aria-valuemax="100"
            style={{ width: winRateB + "%", borderBottom: borderB }}>
            {winRateB.toFixed(1)}
          </div>
          <div className="progress-bar progress-bar-white" role="progressbar"
            aria-valuenow={Math.round(winRateW)}
            aria-valuemin="0" aria-valuemax="100"
            style={{ width: winRateW + "%", borderBottom: borderW }}>
            {winRateW.toFixed(1)}
          </div>
        </div>
      </div>
    )
  }
}

export default WinRate;